import { setCustomDeepLink, resetDeepLink } from 'modules/common/actions/deepLink';
import { redirectLinks, APPOINTMENT_UPDATE } from 'modules/common/constants/redirectLinks';
import { replaceTo } from 'modules/auth/actions/redirectAction';
import { conferenceInProgress } from 'modules/conference/selectors/consultationInfo';
import { selectOrganizationToken } from './organizationSelection';
import { logout } from './logout';

export const checkDeepLinks = (setRedirectChecked) => (dispatch, getState) => {
  const state = getState();
  const location = state.router.location;
  const deepLinkSearch = state.common.deepLink.search;
  const deepLinkSearchParams = new URLSearchParams(deepLinkSearch);
  const params = new URLSearchParams(location.search);
  const selectedOrgId = state.auth.organizations.selectedOrganizationToken;
  const orgId = +params.get('orgId');
  const deepLinkOrgId = +deepLinkSearchParams.get('orgId');
  const currentUserId = state.auth.userInfo.userId;
  const deepLinkUserId = deepLinkSearchParams.get('userId');
  const userId = params.get('userId');

  // check params from available deeplink and compare with user (after login with deep link)
  if (deepLinkSearch && ((deepLinkOrgId !== selectedOrgId) || (deepLinkUserId !== currentUserId))) {
    dispatch(resetDeepLink());
    replaceTo('/appointments');
    return setTimeout(() => setRedirectChecked(true), 1000);
  }

  // check received deeplink params
  if (!userId || !orgId || conferenceInProgress(state)) {
    return setRedirectChecked(true);
  }

  // get link without locale
  let link = `/${ state.router.location.pathname.split('/').slice(2).join('/') }`;

  // check whether deeplink is in the list of supported
  if (!Object.values(redirectLinks).some((value) => value === link)) {
    return setRedirectChecked(true);
  }

  // link modification for appointment update case due to different link structure
  if (link === redirectLinks[APPOINTMENT_UPDATE]) {
    link = `${ link }/${ params.get('appointmentId') }`;
  }

  // check available and received orgId
  if (selectedOrgId !== orgId) {
    // found config mismatch, redirect to login
    return dispatch(logout(true))
      .then(() => {
        dispatch(selectOrganizationToken(orgId));
        setRedirectChecked(true);
      });
  }

  // check available and received userId
  if (localStorage.getItem('jwt')) {
    if (currentUserId === userId) {
      // instant redirect to the link if everything matched
      replaceTo(link);
    } else {
      // found config mismatch, redirect to login
      return dispatch(logout(true))
        .then(() => {
          dispatch(setCustomDeepLink(link, location.search));
          setRedirectChecked(true);
        });
    }
  }

  // set deep link
  dispatch(setCustomDeepLink(link, location.search));
  setRedirectChecked(true);
};
